import axios from 'axios'


export const API = axios.create({
   baseURL: '/api',
   timeout: 10000,
   headers: {
      'content-type': 'application/json'
   }
})

export const arrToMap = arr =>
   arr.reduce((acc, item) => {
      acc[item.id] = item
      return acc
   }, {})

export { app, setTiles, unsetTiles, openSearch, closeSearch, setError, clearError } from './app'
export { article, fetchArticle } from './article'
export { articles, fetchArticles, setArticlesPage } from './articles'
export { brands, fetchBrands } from './brands'
export { cards, fetchCards } from './cards'
export { cart, fetchCart, changeCartItemCount, removeCartItem, clearCart } from './cart'
export { catalogs, fetchCatalogs } from './catalogs'
export { certificates, fetchCertificates } from './certificates'
export { compare, toggleCompare, removeCompareItem } from './compare'
export { filters, startFiltering, endFiltering, startSorting, sortProducts, filterProducts } from './filters'
export { form, submitForm } from './form'
export { home, fetchHome } from './home'
export { menu, fetchMenu } from './menu'
export { order, submitOrder, openModalOrder, closeModalOrder } from './order'
export { products, fetchProducts } from './products'
export { promo, fetchCardsSlice } from './promo'
export { reviews, fetchReviews } from './reviews'
export { similar, fetchSimilar } from './similar'
